import { ArrowDropDown, FilterAltOutlined } from "@mui/icons-material";
import { FC } from "react";

const FilterButton: FC<({
    onClick: () => void;
    isFilterApplied: boolean;
})>
    = ({
        onClick,
        isFilterApplied,
    }) => {

        return (
            <button
                onClick={onClick}
                className="relative flex items-center bg-white border border-gray color-primary rounded-full
                        px-2 py-2 focus:outline-none focus:ring-2 focus:ring-green-200"
            >
                <FilterAltOutlined className="w-4 h-4" />
                <span className="hidden md:flex fs-14">Filters</span>
                <ArrowDropDown />
                {
                    isFilterApplied &&
                    (
                        <span className="absolute -top-1 -right-1 w-2 h-2 bg-orange-500 rounded-full"></span>
                    )
                }
            </button>
        );
    }

export default FilterButton;